import React from 'react'
import { extractSpecificFields } from 'ducks/integrations/shared/settings'
import { Section, SectionLabel } from './Section'
import Properties from './Properties'

const contactPrioritizedFields = ['firstname', 'lastname', 'email']

export default class Contact extends React.PureComponent {
  render() {
    const { contactObject, settings, ownersById } = this.props

    if (!contactObject) return null
    if (!contactObject.data) return null
    const specificFields = extractSpecificFields(
      settings,
      /showSidebarField.Contact\./
    )

    const profileUrl = contactObject && contactObject.data['profile-url']
    return (
      <Section>
        {contactObject &&
          contactObject.state === 'fetched' && (
            <React.Fragment>
              <SectionLabel size="small" as="div">
                Contact
              </SectionLabel>
              <Properties
                properties={contactObject.properties}
                prioritizedFields={contactPrioritizedFields}
                specificFields={specificFields}
                ownersById={ownersById}
              />
              <a href={profileUrl} rel="noopener noreferrer" target="_blank">
                View contact in HubSpot
              </a>
            </React.Fragment>
          )}
      </Section>
    )
  }
}
